import React from "react";
import { Box } from "@mui/material";

const TableHead = (): React.ReactElement => (
  <thead>
    <Box component="tr" sx={{ position: "sticky", top: 0, zIndex: 1 }}>
      <td>Payment Type</td>
      <td>Date</td>
      <td>Amount</td>
      <td>Product</td>
      <td>Name</td>
      <td>last 4 digits</td>
      <td>Failure Code</td>
      <td>Failure Reason</td>
      <td>Seller Message</td>
      <td>Discount code</td>
      <td>Payment Id</td>
      <td>IP</td>
      <td>recorded in DB</td>
    </Box>
  </thead>
);
export default TableHead;
